// hooks/useOrderActions.js
import { useDispatch, useSelector } from "react-redux";
import { selectedsearchProductApi, postOrderbyidApi } from "../services/Apis";
import { setorderSelectedproducts, setsearchinput } from "../slices/globalslice";
import { setorderdatabyid, setorderselectedvendorproducts } from "../slices/orderslice";

const useOrderActions = () => {
    const dispatch = useDispatch();
    const orderSelectedproducts = useSelector((state) => state.globalslice.orderSelectedproducts);
    const profile_Details = useSelector(state => state.globalslice.profile_Details);

    const selectedsearchProduct = async (sku, countryid, areaid) => {
        try {
            const response = await selectedsearchProductApi(sku, countryid, areaid);
            const product = response.data;

            if (product) {

                const isDefaultGroup = profile_Details?.group?.some(g => g.slug === "default");

                if (product.inventory == 0 && isDefaultGroup) {
                    alert("Out Of Stock");
                    return; // Exit early
                }


                // Check for duplicates
                const exists = orderSelectedproducts?.some(p => p.productid === product.productid);
                if (exists) {
                    alert("Product already added.");
                    return; // Exit early
                }
                dispatch(setorderselectedvendorproducts(product))
                // Add product to Redux state
                // dispatch(setorderSelectedproducts([
                //     ...(orderSelectedproducts || []),
                //     product
                // ]));


                dispatch(setsearchinput(false));

                if (response.success === "true") {
                    alert("Product added");
                }
            }
        } catch (error) {
            console.error("Failed to fetch selected product:", error);
        }
    };

    const getOrderById = async (sku) => {
        try {
            const response = await postOrderbyidApi(sku);
            dispatch(setorderdatabyid(response.data[0]))
            if (response.success == "true") {
                alert("Product added");


            }

        } catch (error) {

        }
    };

    return { selectedsearchProduct, getOrderById };
};

export default useOrderActions;
